export const createResourceLookupState = () => {
    return {
        resources: {
            listOfResources: [],
            isListOfResourcesLoading: false,
            isListOfResourcesLoadingSuccess: false,
            isListOfResourcesLoadingFailed: false,
            didReassignSuccess: false,
            isReassignInProgress: false,
            didReassignFail: false,
            didCancelAssignmentSuccess: false,
            isCancelInProgress: false,
            didCancelAssignmentFailed: false,
            updatedJobDate: ''
        },
        assignee: {
            email: '',
            name: '',
            phone: '',
            isAssigneeShopInfoLoading: false,
            isAssigneeShopInfoLoadingSuccess: false,
            isAssigneeShopInfoLoadingFailed: false
        }
    };
};
//# sourceMappingURL=createResourceLookupState.js.map